<template>
  <div class="h-100">
    <div class="container-wrapper">
      <h2 class="title">Програма лояльності</h2>
    </div>
    <div class="horizontal-scroll">
      <div class="right-space">
        <LoyaltyCashbackPanel/>
        </div>
    </div>
  </div>
</template>

<script>
import LoyaltyCashbackPanel from "@/components/loyalty/LoyaltyCashbackPanel.vue";

export default {
  components: {
    LoyaltyCashbackPanel
  }
};
</script>

<style>
</style>